module.exports = __webpack_public_path__ + "img/lr_31.419f2a6b.png";